import {BaseModel} from '../../../model/shared/BaseModel';
import {requests} from '../../../utils';
import {INFLUENCER_MY_CAMPAIGNS} from '../../../utils/endpoints';
import {IMyCampaignItem, IMyCampaignsFilterProps} from './dto/IMyCampaigns';

export const InfluencerMyCampaignsApi = {
    getMyCampaigns: (params: IMyCampaignsFilterProps): Promise<BaseModel<IMyCampaignItem[]>> => requests.get(INFLUENCER_MY_CAMPAIGNS, params),
    getMyCampaignsDeclined: (params: IMyCampaignsFilterProps): Promise<BaseModel<IMyCampaignItem[]>> => requests.get(`${INFLUENCER_MY_CAMPAIGNS}/declined`, params),
};